<div class="dialog-header">
  <span class="titulo">{{ titulo }}</span>
  <button mat-icon-button (click)="fechar()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="dialog-body">

  <div *ngIf="data.sucessos?.length">
    <div class="section-title sucesso">Sucessos:</div>
    <div class="lista">
      <div class="item sucesso-item" *ngFor="let msg of data.sucessos">
        {{ msg }}
      </div>
    </div>
  </div>

  <div *ngIf="data.erros?.length">
    <div class="section-title erro">Erros:</div>
    <div class="lista">
      <div class="item erro-item" *ngFor="let msg of data.erros">
        {{ msg }}
      </div>
    </div>
  </div>

</div>

<div class="dialog-footer">

    <button mat-button class="btn-fundo-vermelho" (click)="fechar()">
        Fechar
        <mat-icon>clear</mat-icon>
    </button>
</div>
